import { Component, OnInit, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { base64StringToBlob } from 'blob-util';
import { saveAs } from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';
import { config } from 'src/app/config/config';
import { AppService } from 'src/app/service/app.service';
import { UserDetailsService } from 'src/app/service/user-details.service';
import { CustomValidators } from 'src/app/shared/customValidators';
import * as CryptoJS from 'crypto-js';
declare var $: any;

const secretKey = config.secretKey;

@Component({
  selector: 'app-register-user',
  templateUrl: './register-user.component.html',
  styleUrls: ['./register-user.component.css']
})
export class RegisterUserComponent implements OnInit, AfterViewInit {

  regForm: FormGroup;
  submitted = false;
  config: any = config;
  captchaSource: string;
  response: any;
  loginForm: FormGroup;
  message: string;
  captchaURL: string;
  randomString: string;
  fieldTextType: boolean = false;
  oldSession: string = "";
  userPattern: string;
  captchaPattern: string;
  fakeConf: string = "";
  // addBankForm: FormGroup;
  entityList: any = [];
  stateList: any = [];
  kycDocList: any = [];
  bsValue: any;
  bsValue1: any;
  file: any;
  regId: string = "";
  user: any = {};
  entityType: any = "";
  makerCheckerForm: FormGroup;
  responseData: any = {};
  uploadedDocs: any = [];
  additionalInfo: any = [];
  menuListFinal: any = [];
  userAccessForm: FormGroup;
  accessMapping: FormArray;
  action: string = 'add';
  validUserLoginId: boolean = false;
  memCode: string;
  memCodeCreation: FormGroup;
  pdfFileError:  any = [];
  registerToken: String = "";

  constructor(private formBuilder: FormBuilder,
    private titleService: Title,
    private router: Router,
    private toastr: ToastrService,
    private cdref: ChangeDetectorRef,
    private appService: AppService,
    private userDetailsService: UserDetailsService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService) {
    this.route.queryParams.subscribe(params => {
      if (params['id']) {
        this.responseData = this.appService.getRegFormByRegID(params['id']);
        this.regId = params['id'];
        this.action = 'edit';
        this.responseData.pan = decryptPAN(this.responseData.pan);
      }

      if (params['registerToken']) {
        this.registerToken = params['registerToken'];
      }

    });
  }

  get rf() { return this.regForm.controls; }

  get bankForm() { return this.regForm.controls['bankAccountDTOList'] as FormArray; }

  get dpForm() { return this.regForm.controls['dpAccountDTOList'] as FormArray; }

  get kycForm() { return this.regForm.controls['kycDocList'] as FormArray }

  get additionalInfoForm() { return this.regForm.controls['additionalDtlsDTOList'] as FormArray }

  get mkrChkrForm() { return this.makerCheckerForm.controls; }

  get f() { return this.userAccessForm.controls; }

  ngOnInit(): void {
    this.titleService.setTitle("Login");
    this.captchaURL = this.config.URL.captchaURL;
    this.userPattern = this.config.data.userPattern;
    this.captchaPattern = this.config.data.captchaPattern;
    if (localStorage.getItem('token')) {
      this.user = this.userDetailsService.getUserDetails() || {};
      this.entityType = this.user.entityType;
    }
    this.makerCheckerForm = this.formBuilder.group({
      makerID: [''],
      makerComment: [''],
      makerDTM: [''],
      checkerID: [''],
      checkerComment: [''],
      checkerDTM: [''],
    });

    this.userAccessForm = this.formBuilder.group({
      checked: false,
      accessMapping: this.formBuilder.array([]),
    });
    this.memCodeCreation = this.formBuilder.group({
      memCodeField1: ['', [Validators.required, Validators.pattern("^[A-Z0-9]{1}$")]],
      memCodeField2: ['', [Validators.required, Validators.pattern("^[A-Z0-9]{1}$")]],
      memCodeField3: ['', [Validators.required, Validators.pattern("^[A-Z0-9]{1}$")]],
      memCodeField4: ['', [Validators.required, Validators.pattern("^[A-Z0-9]{1}$")]],
      memCodeField5: ['', [Validators.required, Validators.pattern("^[A-Z0-9]{1}$")]],
      memCodeField6: ['', [Validators.required, Validators.pattern("^[A-Z0-9]{1}$")]]
    })
    let email = localStorage.getItem('username');
    this.regForm = this.formBuilder.group({
      regID: [this.regId],
      loginName: [this.responseData.loginName || '', [Validators.pattern("^[a-zA-Z0-9]{1}[a-zA-Z0-9_]{4,}$")]], //Validators.required
      pname: [this.responseData.pname, Validators.required],
      // memCode: [this.responseData.memCode || '', Validators.required],
      // panExempt: [this.responseData.panExempt || 'N', Validators.required],
      pan: [this.responseData.pan || '', [Validators.pattern(this.config.data.panCardPattern)]],
      custodian: [this.responseData.custodian || ''],
      entityType: [this.responseData.entityType || '', Validators.required],
      regulatedBySEBI: [(this.responseData.regulatedBySEBI == 'true' ? true : false) || false],
      sebiRegNo: [this.responseData.sebiRegNo || ''],
      regulatedByRBI: [(this.responseData.regulatedByRBI == 'true' ? true : false) || false],
      rbiRegNo: [this.responseData.rbiRegNo || ''],
      regulatedByIFSCA: [(this.responseData.regulatedByIFSCA == 'true' ? true : false) || false],
      ifscaRegNo: [this.responseData.ifscaRegNo || ''],
      // repoEligible: [this.responseData.repoEligible || 'Y', Validators.required],
      // enableSettleNotification: [this.responseData.enableSettleNotification || 'Y', Validators.required],
      contactPersonName: [this.responseData.contactPersonName || '', Validators.required],
      countryCode: [this.responseData.countryCode || 91, [Validators.required, Validators.pattern(this.config.data.countryCodePattern)]],
      mobile: [this.responseData.mobile || '', [Validators.required, Validators.pattern(this.config.data.mobileNoPattern)]],
      email: [this.responseData.email || email, [Validators.required, Validators.email]],
      addrLine1: [this.responseData.addrLine1 || ''], //Validators.required
      addrLine2: [this.responseData.addrLine2 || ''],
      addrLine3: [this.responseData.addrLine3 || ''],
      // gstExempted: [this.responseData.gstExempted || 'N', Validators.required],
      // gstNo: [this.responseData.gstNo || '', [Validators.pattern(this.config.data.gstNoPattern)]],
      leiCode: [this.responseData.leiCode || '', [Validators.pattern(this.config.data.leiCodePattern)]], //Validators.required
      expiryDate: [(this.responseData.expiryDate ? new Date(this.responseData.expiryDate) : '')], //Validators.required
      leiIssuer: [this.responseData.leiIssuer || ''], //Validators.required
      loginID: [this.responseData.loginID || ''],
      createdDTM: [this.responseData.createdDTM || ''],
      modifiedDTM: [this.responseData.modifiedDTM || ''],
      menuList: [this.responseData.menuList || ''],
      status: [this.responseData.status || ''],
      bankAccountDTOList: this.formBuilder.array([]),
      dpAccountDTOList: this.formBuilder.array([]),
      kycDocList: this.formBuilder.array([]),
      additionalDtlsDTOList: this.formBuilder.array([])
    });

    if (this.responseData.bankAccountModelList?.length > 0) {
      this.responseData.bankAccountModelList.forEach(element => {
        const bankItem = this.formBuilder.group({
          regId: [this.regId],
          rbaAccountID: [element.rbaAccountID || ''],
          bankName: [element.bankName || ''], //Validators.required
          bankIFSC: [element.bankIFSC || '', [Validators.pattern(this.config.data.ifscCodePattern)]], //Validators.required
          reenteredBankIFSC: [element.bankIFSC || ''], //Validators.required
          // interBankAccount: [element.interBankAccount || '', Validators.required],
          bankAccountNo: [element.bankAccountNo || ''],
          reenterBankAccountNo: [element.bankAccountNo || ''],
          // defaultAccount: [element.defaultAccount || '', Validators.required]
        }, {
          validator: [CustomValidators.match('bankIFSC', 'reenteredBankIFSC'), CustomValidators.match('bankAccountNo', 'reenterBankAccountNo')]
        });
        this.bankForm.push(bankItem);
      })
    } else {
      this.addNewBank();
    }

    if (this.responseData.dpAccountModelList?.length > 0) {
      this.responseData.dpAccountModelList.forEach(element => {
        const bankItem = this.formBuilder.group({
          regId: [this.regId],
          rdaAccountID: [element.rdaAccountID || ''],
          dpType: [element.dpType || ''], //Validators.required
          dpID: [element.dpID || ''],
          reenteredDpID: [element.dpID || ''],
          beneficiaryID: [element.beneficiaryID || ''], //Validators.required
          reenterBeneficiaryID: [element.beneficiaryID || ''], //Validators.required
          // defaultAccount: ['', Validators.required]
        }, {
          validator: [CustomValidators.match('dpID', 'reenteredDpID'), CustomValidators.match('beneficiaryID', 'reenterBeneficiaryID')]
        });
        this.dpForm.push(bankItem);
      })
    } else {
      this.addNewDP();
    }
    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');
    this.getMemberMenus();
    this.getDynamicFieldList();
    if (this.entityType == "ADMIN" || this.responseData.loginID) {
      this.regForm.disable();
    }
    $(".memCodeClass").keyup(function () {
      if (this.value)
        this.nextElementSibling.focus()
    })
  }

  ngAfterViewInit(): void {
    $('.selectpicker').selectpicker('refresh');
  }

  getDynamicFieldList() {
    this.appService.getDynamicFieldList().pipe(catchError((error: any) => {
      this.cdref.detectChanges();
      if (error.status != 200) {
        return throwError(error.error);
      }
    })).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.entityList = response.data.entityList;
        this.stateList = response.data.stateList;
        this.additionalInfo = response.data.additionalInfo;
        this.kycDocList = response.data.kycDocList;

        this.kycDocList.forEach(element => {
          let fileName = "";
          if (this.responseData.documentList) {
            fileName = this.responseData.documentList[element.key];
          }
          let kycForm = this.formBuilder.group({
            fileType: [element.value],
            kycFile: [''],
            fileName: [fileName]
          })
          this.kycForm.push(kycForm);
          this.uploadedDocs.push({ fileType: element.value, fileID: '' })
          element.fileName = fileName;
        });
        this.additionalInfo.forEach(element => {
          let fieldValue = "";
          let addInfoId = "";
          if (this.responseData?.additionalInfo?.length > 0) {
            fieldValue = this.responseData.additionalInfo.find(data => data.key == element.key).fieldValue;
            addInfoId = this.responseData.additionalInfo.find(data => data.key == element.key).addInfoId;
          }
          let additionalForm = this.formBuilder.group({
            key: [element.key],
            value: [element.value],
            fieldValue: [fieldValue], //Validators.required
            regId: [this.regId],
            addInfoId: [addInfoId],
          })
          this.additionalInfoForm.push(additionalForm);
        })
      } else {
        this.toastr.error(response.message);
      }
      this.cdref.detectChanges();
      $('.selectpicker').selectpicker('refresh');
      if (this.entityType == "ADMIN" || this.responseData.loginID) {
        this.regForm.disable();
      }
    });
  }

  addNewBank() {
    const bankItem = this.formBuilder.group({
      regId: [this.regId],
      rbaAccountID: [''],
      bankName: [''], //Validators.required
      bankIFSC: ['', [Validators.pattern(this.config.data.ifscCodePattern)]], //Validators.required
      reenteredBankIFSC: [''], //Validators.required
      // interBankAccount: ['', Validators.required],
      bankAccountNo: [''], //Validators.required
      reenterBankAccountNo: [''], //Validators.required
      // defaultAccount: ['', Validators.required],
      // bankDocument: ['', Validators.required]
    }, {
      validator: [CustomValidators.match('bankIFSC', 'reenteredBankIFSC'), CustomValidators.match('bankAccountNo', 'reenterBankAccountNo')]
    });
    this.bankForm.push(bankItem);
  }

  addNewDP() {
    const dpItem = this.formBuilder.group({
      regId: [this.regId],
      rdaAccountID: [''],
      dpType: [''], //Validators.required
      dpID: [''],
      reenteredDpID: [''],
      beneficiaryID: [''], //Validators.required
      reenterBeneficiaryID: [''], //Validators.required
      // defaultAccount: ['', Validators.required],
      // dpDocument: ['', Validators.required]
    }, {
      validator: [CustomValidators.match('dpID', 'reenteredDpID'), CustomValidators.match('beneficiaryID', 'reenterBeneficiaryID')]
    });
    this.dpForm.push(dpItem);
  }

  deleteBankItem(index: any) {
    let bankItemArray = <FormArray>this.rf.bankAccountDTOList;
    bankItemArray.removeAt(index);
    this.rf.bankAccountDTOList = bankItemArray;
  }

  deleteDPAccountItem(index: any) {
    let dpAccountItemArray = <FormArray>this.rf.dpAccountDTOList;
    dpAccountItemArray.removeAt(index);
    this.rf.dpAccountDTOList = dpAccountItemArray;
  }

  back() {
    this.router.navigate(['../']);
  }

  register() {
    this.submitted = true;
    if (this.regForm.invalid) {
      this.toastr.warning("Please enter required details");
      return;
    }

    let requestObject = this.regForm.value;
    requestObject.status = 'SUBMITTED';
    requestObject.pan = encryptPAN(requestObject.pan);

    this.appService.saveOrSubmitData(requestObject, this.registerToken).pipe(
      catchError((error: any) => {
        this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.regId = response.data.regID;
        this.toastr.success("User registration initiated successfully");
        this.router.navigate(['/registeruser'], { queryParams: { 'registerToken': this.registerToken} });
      }
      else if (response.statusCode == 401){
        this.toastr.warning(response.message);
        this.router.navigate(['/registeruser']);
      }
    });
  }

  uploadRegisterFile(file, fileType, i) {


    if (file && file.files[0]) {
      this.file = file.files[0];
      if (this.file.type == 'application/pdf' && this.file.size <= 10000000) {

        const suspiciousPattern = /[<>:"/\\|?*%]/;

        if(suspiciousPattern.test(this.file.name)){
          this.file = null;
          this.rf.kycDocList['controls'][i]['controls'].kycFile.setValue(null);
          this.pdfFileError[i] = true;
          return;
        }
        
        this.pdfFileError = false;

      } else {
        this.file = null;
        this.rf.kycDocList['controls'][i]['controls'].kycFile.setValue(null);
        this.pdfFileError[i] = true;
        // this.cdref.detectChanges();
        return;
      }
    }

    this.file = file.files[0];
    let requestObject = this.regForm.value;
    if (!requestObject.bankAccountDTOList[0].regId) {
      requestObject.bankAccountDTOList = null;
    }
    if (!requestObject.dpAccountDTOList[0].regId) {
      requestObject.dpAccountDTOList = null;
    }
    if (!requestObject.additionalDtlsDTOList[0].regId) {
      requestObject.additionalDtlsDTOList = null;
    }

    requestObject.pan = encryptPAN(requestObject.pan);

    this.appService.saveOrSubmitData(requestObject, this.registerToken).pipe(catchError((error: any) => {
      this.rf.kycDocList['controls'][i]['controls'].kycFile.setValue(null);
      this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
      if (error.status != 200) {
        return throwError(error.error);
      }
    })).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.regId = response.data.regID;
        let bankItemArray = <FormArray>this.rf.bankAccountDTOList;
        for (let i = 0; i < bankItemArray.length; i++) {
          bankItemArray.at(i).patchValue({ regId: this.regId, rbaAccountID: response.data.bankAccountModelList ? response.data.bankAccountModelList[i]?.rbaAccountID : '' })
        }
        this.rf.bankAccountDTOList = bankItemArray;
        let dpAccountItemArray = <FormArray>this.rf.dpAccountDTOList;
        for (let i = 0; i < dpAccountItemArray.length; i++) {
          dpAccountItemArray.at(i).patchValue({ regId: this.regId, rdaAccountID: response.data.dpAccountModelList ? response.data.dpAccountModelList[i]?.rdaAccountID : '' })
        }
        this.rf.dpAccountDTOList = dpAccountItemArray;
        let additionalInfoArray = <FormArray>this.rf.additionalDtlsDTOList;
        for (let i = 0; i < additionalInfoArray.length; i++) {
          additionalInfoArray.at(i).patchValue({ regId: this.regId, addInfoId: response.data.additionalInfo ? response.data.additionalInfo[i]?.addInfoId : '' })
        }
        this.rf.additionalDtlsDTOList = additionalInfoArray;
        let fileID = this.uploadedDocs.filter(element => element.fileType == fileType).fileID;
        this.appService.uploadRegisterFile(this.registerToken, this.file, fileType, this.regId, fileID).pipe(catchError((error: any) => {
          this.rf.kycDocList['controls'][i]['controls'].kycFile.setValue(null);
          this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
          if (error.status != 200) {
            return throwError(error.error);
          }
        })).subscribe((response: any) => {
          if (response.statusCode == 200) {
            this.regId = response.data.regID;
            this.rf.regID.setValue(this.regId);
            let bankItemArray = <FormArray>this.rf.bankAccountDTOList;
            for (let i = 0; i < bankItemArray.length; i++) {
              bankItemArray.at(i).patchValue({ regId: this.regId })
            }
            this.rf.bankAccountDTOList = bankItemArray;
            let dpAccountItemArray = <FormArray>this.rf.dpAccountDTOList;
            for (let i = 0; i < dpAccountItemArray.length; i++) {
              dpAccountItemArray.at(i).patchValue({ regId: this.regId })
            }
            this.rf.dpAccountDTOList = dpAccountItemArray;
            let additionalInfoArray = <FormArray>this.rf.additionalDtlsDTOList;
            for (let i = 0; i < additionalInfoArray.length; i++) {
              additionalInfoArray.at(i).patchValue({ regId: this.regId })
            }
            this.rf.additionalDtlsDTOList = additionalInfoArray;
            this.uploadedDocs.filter(element => element.fileType == fileType).fileID = response.data.fileID;
            this.toastr.success(response.message);
          } else {
            this.rf.kycDocList['controls'][i]['controls'].kycFile.setValue(null);
            this.toastr.error(response.message);
          }
        })
      } else {
        this.rf.kycDocList['controls'][i]['controls'].kycFile.setValue(null);
        this.toastr.warning(response.data);
      }
    });
  }

  makerCheckerAction(action: any) {
    // this.memCode = 'IC' + this.rf.entityType.value;
    $("#memCodeCreation").modal('show');
  }

  makerCheckerAction2(action: any) {
    let requestObject = this.regForm.value;
    requestObject.status = action;

    requestObject.pan = encryptPAN(requestObject.pan);

    requestObject.memCode = this.memCodeCreation.controls.memCodeField1.value + this.memCodeCreation.controls.memCodeField2.value + this.memCodeCreation.controls.memCodeField3.value + this.memCodeCreation.controls.memCodeField4.value+ this.memCodeCreation.controls.memCodeField5.value+ this.memCodeCreation.controls.memCodeField6.value;
    requestObject.makerComment = this.mkrChkrForm.makerComment.value;
    requestObject.checkerComment = this.mkrChkrForm.makerComment.value;
    this.appService.makerCheckerAction(requestObject).pipe(catchError((error: any) => {
      if (error.status != 200) {
        return throwError(error.error);
      }
    })).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.toastr.success(response.message)
        this.router.navigate(['/admin/userApproval']);
      } else {
        this.toastr.success(response.message);
        this.router.navigate(['/admin/userApproval']);
      }
    });
  }

  downloadFile(fileName) {
    this.appService.downloadRegisterFile(fileName).pipe(catchError((error: any) => {
      this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
      if (error.status != 200) {
        return throwError(error.error);
      }
    })).subscribe((response: any) => {
      if (response.statusCode == 200) {
        let file = response.data;
        let contentType = 'application/octet-stream';
        let blob = base64StringToBlob(file, contentType);
        saveAs(blob, fileName, {
          autoBOM: true
        });
        this.toastr.success(response.message);
      } else {
        this.toastr.error(response.message);
      }
    })
  }

  getMemberMenus() {
    this.appService.getMemberMenus().pipe(catchError((error: any) => {
      if (error.status != 200) {
        return throwError(error.error);
      }
    })).subscribe((response: any) => {
      this.menuListFinal = response.data[0];
      this.setFormData();
    });
  }

  setFormData() {
    let accessMappingControl = <FormArray>this.f.accessMapping;
    this.menuListFinal.forEach((element, index) => {
      let accessType = 'N';
      if (this.responseData?.menuList?.split(",").some(str => str == element.menuCode)) {
        accessType = 'Y';
      }
      accessMappingControl.push(this.formBuilder.group({
        checked: false,
        verify: false,
        userMenuMapId: [element.userMenuMapId],
        userId: [element.userId],
        menuId: [element.menuId],
        menuName: [element.menuName],
        menuCode: [element.menuCode],
        isAccessAllowed: [accessType],
        userMenusImpls: this.formBuilder.array([])
      }));

      if (element.userMenusImpls) {
        element.userMenusImpls.forEach(element1 => {
          let accessType1 = 'N';
          if (this.responseData?.menuList?.split(",").some(str => str == element1.menuCode)) {
            accessType1 = 'Y';
          }
          (accessMappingControl.at(accessMappingControl.length - 1).get('userMenusImpls') as FormArray).push(this.formBuilder.group({
            checked: false,
            verify: false,
            userMenuMapId: [element1.userMenuMapId],
            userId: [element1.userId],
            menuId: [element1.menuId],
            menuName: [element1.menuName],
            menuCode: [element1.menuCode],
            isAccessAllowed: [accessType1],
            userMenusImpls2: this.formBuilder.array([])
          }))

          //   let menuMappingControl = <FormArray>(accessMappingControl.at(accessMappingControl.length - 1).get('userMenusImpls') as FormArray);
          //   if (element1.userMenusImpls) {
          //     element1.userMenusImpls.forEach(element2 => {
          //       (menuMappingControl.at(menuMappingControl.length - 1).get('userMenusImpls2') as FormArray).push(this.formBuilder.group({
          //         checked: false,
          //         verify: false,
          //         userMenuMapId: [element2.userMenuMapId],
          //         userId: [element2.userId],
          //         menuId: [element2.menuId],
          //         menuName: [element2.menuName],
          //         menuCode: [element2.menuCode],
          //         isActive: [element2.isActive],
          //         isDeleted: [element2.isDeleted],
          //         checkedStatus: [element2.checkedBy ? 'approve' : null],
          //         checkedBy: [element2.checkedBy || null],
          //         checkedDate: [element2.checkedDate || null],
          //         createdBy: [element2.createdBy],
          //         createdDate: [element2.createdDate],
          //         lastModifiedBy: [element2.lastModifiedBy],
          //         lastModifiedDate: [element2.lastModifiedDate],
          //       }))
          //     });
          //   }
        });
      }
    });
    this.accessMapping = <FormArray>this.f.accessMapping;
    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');
  }

  detectChange() {
    if (this.rf.regulatedBySEBI.value) {
      this.rf.sebiRegNo.addValidators(Validators.required);
    } else {
      this.rf.sebiRegNo.clearValidators();
    }
    if (this.rf.regulatedByRBI.value) {
      this.rf.rbiRegNo.addValidators(Validators.required);
    } else {
      this.rf.rbiRegNo.clearValidators();
    }
    if (this.rf.regulatedByIFSCA.value) {
      this.rf.ifscaRegNo.addValidators(Validators.required);
    } else {
      this.rf.ifscaRegNo.clearValidators();
    }

    this.rf.sebiRegNo.updateValueAndValidity();
    this.rf.rbiRegNo.updateValueAndValidity();
    this.rf.ifscaRegNo.updateValueAndValidity();
    this.cdref.detectChanges();
  }

  // checkLoginId() {
  //   if (this.rf.loginName.valid) {
  //     let requestObject = {
  //       'loginName': this.rf.loginName.value,
  //       'regID': this.rf.regID.value || 0
  //     }
  //     this.appService.checkLoginId(requestObject).pipe(catchError((error: any) => {
  //       if (error.status != 200) {
  //         return throwError(error.error);
  //       }
  //     })).subscribe((response: any) => {
  //       if (response.statusCode == 200) {
  //         this.validUserLoginId = true;
  //       } else {
  //         this.validUserLoginId = false;
  //         this.toastr.warning(response.message);
  //       }
  //     });
  //   }
  // }

  cancel() {
    this.router.navigate(['../registeruser'], { queryParams: { 'registerToken': this.registerToken} });
  }

}

export function encryptPAN(pan: string): string {

  const ciphertext = CryptoJS.AES.encrypt(pan, secretKey).toString();
  return ciphertext;

}


export function decryptPAN(encryptedPAN: string): string {

  const bytes = CryptoJS.AES.decrypt(encryptedPAN, secretKey);
  const originalText = bytes.toString(CryptoJS.enc.Utf8);
  return originalText;
  
}
